export default "__VITE_ASSET__3cd6676b__"